/* eslint-disable */

const userPoolsId = process.env.REACT_APP_COGNITO_POOLS_ID;
const userPoolsWebId = process.env.REACT_APP_POOLS_WEB_CLIENT_ID;
const domain = process.env.REACT_APP_COGNITO_DOMAIN;
const redirectSignIn = process.env.REACT_APP_REDIRECT_SIGNIN;
const redirectSignOut = process.env.REACT_APP_REDIRECT_SIGNOUT;

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: userPoolsId,
  aws_user_pools_web_client_id: userPoolsWebId,
  oauth: {
    domain,
    redirectSignIn,
    redirectSignOut,
    responseType: "token"
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_cognito_username_attributes: [
    "EMAIL"
  ],
  aws_cognito_social_providers: [
    "FACEBOOK",
    "GOOGLE"
  ],
  aws_cognito_signup_attributes: [],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      "REQUIRES_NUMBERS"
    ]
  },
  aws_cognito_verification_mechanisms: [
    "EMAIL"
  ]
};


export default awsmobile;
